export interface Image {
    iconPath: string;
    altText: string;
}
export interface Location {
    locationName: string;
	addressLine1: string;
	addressLine2: string;
	addressLine2Optional: string;
	city: string;
	state: string;
	zipCode: string;
}

export interface IdLabel{
	id: string;
	label: string;
}

export interface LabelValue{
	label: string; 
	value: string;
	icon?: Image;
}
export enum SortOrder {
	desc = 'desc',
	asc = 'asc',
}

export interface Address{
	addressLine1:string;
	addressLine2?:string;
	city:string;
	state:string;
	country?: string;
	zipCode:string;
  }
export interface RedirectRoute {
	label: string;
	value: string | boolean | number;
	userId?:string;
	customerId ? : string;
	locationObj ? : Address |undefined;
	orderId?: string;
	locationId?: string;
	documentURL?: string | undefined;
  }
export interface Address{
	addressLine1: string;
	addressLine2?: string;
	city: string;
	state: string;
	country?:string;
	zipCode: string;
  }
export interface WidgetsComingSoon{
imagePath:string;
imageText:string;
title?:string;
  }

export enum DealerPage 
{
  dashboard = 'Dashboard',
  serviceManagement = 'Service Management',
  orderMangement= 'Order Management'
}

export enum HeaderNav{
	dashboard = 'Home',
	raymondDashboard = 'Dashboard',
	myfleet='MyFleet',
	myQuotes= 'Quotes',
	myInsights= 'Connected Solutions',
	financing='Financing',
	orderMangement= 'Orders',
	serviceManagement = 'Service and Repairs',
	switchRole = 'Switch Role'
}

export enum HeaderUrl {
	dashboard = '/dashboard',
	myfleet='/myfleet',
	financing='/financing',
	orderMangement= 'order-management',
	serviceManagement = '/service-management',
	accountSetting = '/account-settings',
	locationManagment = '/location-management',
	rolesPermissions = '/roles-permissions',
	userManagement = '/user-management',
	myQuotes='/myquotes',
	myInsights='/my-insights',
	notification = '/notification',
	analyticReporting = '/analytics-reporting'
}

export interface TooltipContent{
	content:string;
	closeIcon: Image;
}
export interface TokenDataList {
	name: string;
	text: string;
	url: string;
	isLink: string;
  }

export type AllDataType = string | number | boolean | undefined;

export type FieldValueType = string | boolean | number;
